/**
 * Formats a time in 24-hour format. ex 00:00, 23:59
 * @param hours
 * @param minutes
 */
export function formatTime(hours: number, minutes: number) {
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}
